import { ActivityService } from '@omni/services/activity/activity.service';
import { Injectable } from "@angular/core";
import { Endpoints } from '../../../config/endpoints.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CallPlanOfflineService } from '../../services/call-plan/call-plan.offline.service';
import { DiskService } from '../../services/disk/disk.service';
import { RepCallPlanState } from "../../classes/call-plan/rep-call-plan.class";
import { DeviceService } from '../../services/device/device.service';
import { AuthenticationService } from '../../services/authentication.service';
import { DB_SYNC_STATE_KEYS, DB_KEY_PREFIXES } from '../../config/pouch-db.config';
import { DeltaService, EntityNames, EntitySyncInfo } from "../delta/delta.service";
import { FeatureActionsMap, IoConfigurationFeatureCodes } from "../../classes/authentication/user.class";
import { SyncFeatureCategory } from '../../enums/delta-service/delta-service.enum';
import { DynamicsClientService } from "../dynamics-client/dynamics-client.service";
import { fetchQueries } from "@omni/config/dynamics-fetchQueries";
import { differenceInHours, endOfQuarter, format, isBefore, startOfQuarter } from "date-fns";
import { SearchConfigService } from '@omni/services/search/search-config.service';
import { Contact } from '@omni/classes/contact/contact.class';
import { UIService } from '@omni/services/ui/ui.service';
import { Activity } from '@omni/classes/activity/activity.class';
import { Events } from '@omni/events'
import { FeatureActionsService } from "@omni/services/feature-actions/feature-actions.service";
import { CustomerEventsDataService } from '../customer-event/customer-events.data.service';
import { VirtualSegmentDataService } from '../virtual-segment/virtual-segment.data.service';
import { MyAssistantService, NOTIFICATION } from "@omni/services/my-assistant/my-assistant.service";
import { IndNotificationDataModel } from "@omni/models/indNotificationDataModel";
import { TranslateService } from "@ngx-translate/core";
import { groupBy } from '@omni/services/location/utils';
import { cloneDeep, isEmpty, orderBy } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class CallPlanDataService {

    constructor(
        private http: HttpClient,
        private disk: DiskService,
        private callPlanOffline: CallPlanOfflineService,
        private device: DeviceService,
        private authenticationService: AuthenticationService,
        private deltaService: DeltaService,
        private readonly dynamics: DynamicsClientService,
        private searchConfigService: SearchConfigService,
        private uiService:UIService,
        private activityService: ActivityService,
        private events: Events,
        private faService: FeatureActionsService,
        public customerEventDataService: CustomerEventsDataService,
        private virtualSegmentDataService: VirtualSegmentDataService,
        private translate: TranslateService,
        private myAssistantService: MyAssistantService,
    ) {}

    /**
     *  Used for updating a call plan goals and state, eg approve it and set goals for 30
     *
     * @param {number} state
     * @param {number} status
     * @param {number} suggestedEmails
     * @param {number} suggestedCalls
     * @param {number} suggestedF2FMeetings
     * @param {number} suggestedRemoteMeetings
     * @param {number} suggestedPhoneCallMeetings
     * @memberof CallPlanDataService
     */
    public async updateCallPlan(callPlan, state: number, status: number, suggestedEmails?: number, suggestedCalls?: number, suggestedF2FMeetings?:number,suggestedRemoteMeetings?:number,suggestedPhoneCallMeetings?:number, suggestedEvents?:number, offlineUpdateReqd?:boolean) {
      const url = this.authenticationService.userConfig.activeInstance.entryPointUrl
        + Endpoints.callplans.UPDATE_CUSTOMER_CALL_PLAN.replace('{callPlanId}', callPlan.indskr_customercallplanid);
        if (!this.device.isOffline) {
            try {
                let response = await this.http.patch(url, {
                    indskr_customercallplanid: callPlan.indskr_customercallplanid,
                    statecode: state,
                    statuscode: status,
                    indskr_suggestedemails: suggestedEmails ? suggestedEmails : 0,
                    indskr_suggestedcalls: suggestedCalls ? suggestedCalls : 0,
                    indskr_isrepcallplan: true,
                    indskr_suggestedf2fmeetings:suggestedF2FMeetings ?suggestedF2FMeetings : 0,
                    indskr_suggestedremotemeetings:suggestedRemoteMeetings?suggestedRemoteMeetings:0,
                    indskr_suggestedphonecallmeetings:suggestedPhoneCallMeetings?suggestedPhoneCallMeetings:0,
                    indskr_suggestedevents: suggestedEvents ? suggestedEvents : 0,
                    //-----------------//Allow Reps to submit Call plans adjustments//-----------------//
                    indskr_commentsforcalls: callPlan.indskr_commentsforcalls ? callPlan.indskr_commentsforcalls : '',
                    indskr_commentsforemails: callPlan.indskr_commentsforemails ? callPlan.indskr_commentsforemails : '',
                    indskr_commentsforf2fmeetings: callPlan.indskr_commentsforf2fmeetings ? callPlan.indskr_commentsforf2fmeetings : '',
                    indskr_commentsforremotemeetings: callPlan.indskr_commentsforremotemeetings ? callPlan.indskr_commentsforremotemeetings : '',
                    indskr_commentsforphonecallmeetings: callPlan.indskr_commentsforphonecallmeetings ? callPlan.indskr_commentsforphonecallmeetings : '',
                    indskr_commentsforevents: callPlan.indskr_commentsforevents ? callPlan.indskr_commentsforevents : '',
                    //-----------------//Allow Reps to submit Call plans adjustments//-----------------//
                }).toPromise();
                console.log('Updated call plan', response);
            } catch (httpError) {
                console.error('Caught error trying to update a call plan status', httpError);
                throw httpError;
            }
        }
        //Mark call plan as for review if status was open
        if (callPlan.statuscode == RepCallPlanState.Open) {
            callPlan.statuscode = RepCallPlanState.ForReview;
        //Mark call plan as approved if status was for review and status passed was approval
        } else if (callPlan.statuscode == RepCallPlanState.ForReview && status == RepCallPlanState.Approved) {
            callPlan.indskr_hocalls = suggestedCalls;
            callPlan.indskr_hoemails = suggestedEmails;
            callPlan.indskr_f2fgoals =suggestedF2FMeetings;
            callPlan.indskr_remotemeetinggoals =suggestedRemoteMeetings
            callPlan.indskr_phonecallgoals=suggestedPhoneCallMeetings
            callPlan.indskr_eventgoals=suggestedEvents

            callPlan.statuscode = RepCallPlanState.Approved;
        //Mark call plan as open if status was reject and status passed was reject
        } else if (callPlan.statuscode == RepCallPlanState.ForReview && status == RepCallPlanState.NotApproved) {
            callPlan.statuscode = RepCallPlanState.Open;
        }
        if(offlineUpdateReqd) await this.disk.updateOfflineRepCallPlan(this.callPlanOffline.selectedRepCallPlan);
        const selectedCallPlan = this.callPlanOffline.selectedCallPlan;
        if (selectedCallPlan?.repPlans) {
          selectedCallPlan.allRepCallPlansApproved = selectedCallPlan.repPlans.every(repCP =>
            (repCP.indskr_customercallplanid === callPlan.indskr_customercallplanid ? callPlan : repCP).statuscode === RepCallPlanState.Approved);
        }
        await this.updateSegmentCallPlan({ isTeamCallPlan: selectedCallPlan?.isTeamCallPlan, repPlans: [callPlan] });
        this.events.publish('callPlanActivitiesUpdated');
    }

    public async updateSegmentCallPlan(segmentCallPlan):Promise<any>{
        const repPlans = segmentCallPlan?.repPlans;
        if (isEmpty(repPlans)) return;
        const replaceRepCallPlansById = (callPlans: any[]) => repPlans.forEach(repPlan => {
          const index = callPlans.findIndex(callPlan => callPlan['indskr_customercallplanid'] == repPlan['indskr_customercallplanid']);
          if (index >= 0) callPlans[index] = repPlan;
        });
        const callPlanHandle = segmentCallPlan.isTeamCallPlan ? this.callPlanOffline.teamSegmentCallPlans : this.callPlanOffline.segmentCallPlans;
        if (Array.isArray(callPlanHandle)) replaceRepCallPlansById(callPlanHandle);
        if (!segmentCallPlan.isTeamCallPlan) {
          await this.disk.updateOrInsert(DB_KEY_PREFIXES.MY_POSITON_CALL_PLANS, (doc) => {
            if (!Array.isArray(doc?.raw)) doc = { raw: [] };
            replaceRepCallPlansById(doc.raw);
            return doc;
          });
        }
    }

     private _escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

     replaceAll(str, find, replace) {
      return str.replace(new RegExp(this._escapeRegExp(find), 'g'), replace);
    }


    async getCallPlans(dataRange: { from: string, to: string },fullSync? : boolean, loadFromDBOnly?:boolean, segmentPlanID?:string){
      try {
        if(loadFromDBOnly) {
          this.events.publish('callPlanActivitiesUpdated');
          return;
        }
        let deletedSegmentPlans = [];
        let modifiedCycleplanIdsToFreshCallPlanIdsPromise: Promise<Record<string, Record<string, boolean>>> = Promise.resolve({});
        let lastModifiedForDeltaSync;
        let existingMyPositionPlanIds = new Set<string>();
        let existingMyPositionPlans = new Map<string, any>();
        const shouldFilterApprovedCallPlans = !!(this.authenticationService.user.buSettings
          && (
            (
              this.faService.getFeatureAction(FeatureActionsMap.CALL_PLAN_HOME_SCREEN_STYLE_A)?.getIsOn()
              && !(this.faService.getFeatureAction(FeatureActionsMap.CALL_PLAN_HOME_SCREEN_STYLE_B)?.getIsOn())
              && this.authenticationService.user.buSettings['indskr_displayonlyapprovedcallplansinstylea']
            )
            || (
              this.faService.getFeatureAction(FeatureActionsMap.CALL_PLAN_HOME_SCREEN_STYLE_B)?.getIsOn()
              && this.authenticationService.user.buSettings['indskr_displayonlyapprovedcallplansinstyleb']
            )
          )
        );
        let needToRunApproveStatusFilterOnExistingRecords = false;
        let now = new Date();
        let hourDifference;
        await this.disk.retrieve(DB_KEY_PREFIXES.MY_POSITON_CALL_PLANS).then(data=>{
          if(!data || !data.raw){
            fullSync = true
          }
          else if(!fullSync && !segmentPlanID){
            lastModifiedForDeltaSync = data.lastUpdated
            needToRunApproveStatusFilterOnExistingRecords = shouldFilterApprovedCallPlans && !data.ranApproveStatusFiltering;
            data.raw.forEach(r => {
              existingMyPositionPlans.set(`${r.cycleplanid}:${r.indskr_customercallplanid}`, r);
              existingMyPositionPlanIds.add(`${r.cycleplanid}:${r.indskr_customercallplanid}`);
            });
          }
          else if(segmentPlanID){
            let applicablePlans = data.raw.filter(o=>o.cycleplanid == segmentPlanID);
            if(applicablePlans.length){
              let iterator = 0
              do {
                if(applicablePlans[iterator].lastUpdated){
                  lastModifiedForDeltaSync = applicablePlans[iterator].lastUpdated;
                }
                iterator++;
                } while (applicablePlans[iterator] && !lastModifiedForDeltaSync);
            }
          }
        })
        if(!fullSync && !segmentPlanID){
          //fetch reopened segmentplans for removing related replplans from offline db
          deletedSegmentPlans = await this.dynamics.retrieveAll('indskr_trackchanges',['createdon','indskr_entityid'],
                                                    `indskr_action eq 548910006
                                                        and indskr_entityname eq 'indskr_cycleplan'
                                                        and createdon ge ${new Date(lastModifiedForDeltaSync).toISOString()}`)
                                                    .then(res => res.value).catch(()=> []);
        }
        //Contact Call Plan
        let fetchXML1 = fetchQueries.callPlans.myPositionCallPlans;
        let fetchXML2 = fetchQueries.callPlans.otherCoveragePositionCallPlans;
        let positionIDstring = '';

        // Fetch extra attributes for Short Call Launcher FA
        let extraAttributesValue = '';
        if (this.authenticationService.hasFeatureAction(FeatureActionsMap.SHORT_CALL_LAUNCHER)) {
          extraAttributesValue = `<attribute name="indskr_totalcallgoals" /><attribute name="indskr_totalcompletedcalls" /><attribute name="indskr_primarysegmentation" />`;
        }
        // Add marketing segment attribute if BU_CONSENT_GA_FETCHRTM feature code is enabled
        if (this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONSENT_GA_FETCHRTM)) {
          extraAttributesValue += '<attribute name="indskr_marketingsegmentvirtual" alias="marketingsegmentvirtualid" />';
        }
        fetchXML1 = fetchXML1.replace('{extraAttributes}', extraAttributesValue);
        fetchXML2 = fetchXML2.replace('{extraAttributes}', extraAttributesValue);
        //position filters
        fetchXML1 = fetchXML1.split('{positionAttributeIdentifier}').join('positionid');
        fetchXML2 = fetchXML2.split('{positionAttributeIdentifier}').join('positionid');
        this.authenticationService.user.positions.forEach((pos)=>{
          positionIDstring+= '<value>'+ pos.ID +'</value>'
        })
        fetchXML1 = fetchXML1.split('{positionIDs}').join(positionIDstring);
        fetchXML2 = fetchXML2.split('{positionIDs}').join(positionIDstring);

        //data range
        const startDate = format(parseInt(dataRange.from),'YYYY-MM-DD');
        const endDate = format(parseInt(dataRange.to),'YYYY-MM-DD');
        fetchXML1 =  this.replaceAll(fetchXML1,'{startDate}', startDate)
        fetchXML2 = this.replaceAll(fetchXML2, '{startDate}', startDate)
        fetchXML1 = this.replaceAll(fetchXML1, '{endDate}', endDate)

         fetchXML2 = this.replaceAll(fetchXML2, '{endDate}', endDate)
         //delta sync filter
        let deltaSyncFilter;
        if(lastModifiedForDeltaSync && !fullSync){
          hourDifference = differenceInHours(now,new Date(lastModifiedForDeltaSync))
          //add one to make sure we take care of fractional difference in hours
          hourDifference += 1
          deltaSyncFilter = `<condition attribute="modifiedon" operator="last-x-hours" value="${hourDifference}"/>`
        }
        else deltaSyncFilter = '';
        fetchXML1 = fetchXML1.replace('{modifiedOnFilter}',deltaSyncFilter);
        fetchXML2 = fetchXML2.replace('{modifiedOnFilter}',deltaSyncFilter);

        // During delta sync, fetch all current call plan IDs for cycleplans modified since last sync
        // to detect stale local records (e.g. plans deleted due to segment membership changes)
        if (!fullSync && !segmentPlanID && lastModifiedForDeltaSync && hourDifference) {
          let fetchXMLModifiedCycleplans = fetchQueries.callPlans.callPlanIdsForModifiedCyclePlans;
          fetchXMLModifiedCycleplans = fetchXMLModifiedCycleplans.split('{positionIDs}').join(positionIDstring);
          fetchXMLModifiedCycleplans = this.replaceAll(fetchXMLModifiedCycleplans, '{startDate}', startDate);
          fetchXMLModifiedCycleplans = this.replaceAll(fetchXMLModifiedCycleplans, '{endDate}', endDate);
          fetchXMLModifiedCycleplans = fetchXMLModifiedCycleplans.replace('{hourDifference}', String(hourDifference));
          modifiedCycleplanIdsToFreshCallPlanIdsPromise = this.dynamics.executeFetchQuery<{cycleplanid: string, indskr_customercallplanid: string}>('indskr_customercallplans', fetchXMLModifiedCycleplans)
            .then(res => groupBy(res,
              [[r => r.cycleplanid, r => r.indskr_customercallplanid]], [() => true])?.[0] || {})
            .catch(() => ({}));
        }

        let extraFilter = '';
        // Filter only approved customer call plans for initial sync
        // We need to locally filter for delta synced data
        if (!deltaSyncFilter && shouldFilterApprovedCallPlans) {
          extraFilter = '<condition attribute="statuscode" operator="eq" value="2" />';
        }
        fetchXML1 = fetchXML1.replace('{customerCallPlanFilter}', extraFilter);
        fetchXML2 = fetchXML2.replace('{customerCallPlanFilter}', extraFilter);

        //segmentPlanID filter
        let planIDFilterString;
        planIDFilterString = segmentPlanID? `<filter><condition attribute="indskr_cycleplanid" operator="eq" value="${segmentPlanID}"></condition></filter>`:''
        fetchXML1 = fetchXML1.replace('{segmentPlanFilter}',planIDFilterString);
        fetchXML2 = fetchXML2.replace('{segmentPlanFilter}',planIDFilterString);

        fetchXML2 = fetchXML2.replace('{segmentPlanInnerFilter}', '');
        // Fetch customertype to distinguish account call plan data
        // This data is needed only with the 'CALL_PLAN_HOME_SCREEN_STYLE_B' FA for now.
        fetchXML1 = fetchXML1.replace(
          '{segmentPlanExtraAttributes}',
          this.authenticationService.hasFeatureAction(FeatureActionsMap.CALL_PLAN_HOME_SCREEN_STYLE_B)
            ? '<attribute name="indskr_customertype" alias="customertype"/>'
            : '',
        );
        fetchXML2 = fetchXML2.replace(
          '{segmentPlanExtraAttributes}',
          this.authenticationService.hasFeatureAction(FeatureActionsMap.CALL_PLAN_HOME_SCREEN_STYLE_B)
            ? '<attribute name="indskr_customertype" alias="customertype"/>'
            : '',
        );

        let tasks = []
        tasks.push(this.dynamics.executeFetchQuery('indskr_customercallplans',fetchXML1));
        tasks.push(this.dynamics.executeFetchQuery('indskr_customercallplans',fetchXML2));

        // Fetch virtual segments in parallel if BU_CONSENT_GA_FETCHRTM feature code is enabled
        let virtualSegmentSyncPromise: Promise<void> = Promise.resolve();
        if (this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONSENT_GA_FETCHRTM)) {
          virtualSegmentSyncPromise = this.virtualSegmentDataService.syncVirtualSegments(fullSync || false, false);
        }

        /**
         * Account Call Plan - FetchXML
         * link-entity inner join is not working on the condition that from different entities(contact, account) to the same attribute(indskr_customerid)
         * That's why using additional fetchXML for the account call plan
         */
        // Call plan dashboard style B only requires my position account call plans
        if (this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_CALL_PLAN) || this.authenticationService.hasFeatureAction(FeatureActionsMap.CALL_PLAN_HOME_SCREEN_STYLE_B)) {
          let fetchXML3 = fetchQueries.callPlans.myPositionCallPlansAccounts;
          //position filters
          fetchXML3 = fetchXML3.split('{positionAttributeIdentifierLevel1}').join('positionid');
          fetchXML3 = fetchXML3.split('{positionIDsLevel1}').join(positionIDstring);
          //data range
          fetchXML3 = this.replaceAll(fetchXML3,'{startDate}', startDate);
          fetchXML3 = this.replaceAll(fetchXML3, '{endDate}', endDate);
          //delta sync filter
          fetchXML3 = fetchXML3.replace('{modifiedOnFilter}',deltaSyncFilter);
          fetchXML3 = fetchXML3.replace('{customerCallPlanFilter}', extraFilter);
          //segmentPlanID filter
          fetchXML3 = fetchXML3.replace('{segmentPlanFilter}',planIDFilterString);
          // Replace extraAttributes for account call plans
          fetchXML3 = fetchXML3.replace('{extraAttributes}', extraAttributesValue);

          tasks.push(this.dynamics.executeFetchQuery('indskr_customercallplans',fetchXML3));
        }
        if (this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_CALL_PLAN)) {
          let fetchXML4 = fetchQueries.callPlans.otherCoveragePositionCallPlansAccounts;
          fetchXML4 = fetchXML4.split('{positionAttributeIdentifier}').join('positionid');
          fetchXML4 = fetchXML4.split('{positionIDs}').join(positionIDstring);
          fetchXML4 = this.replaceAll(fetchXML4, '{startDate}', startDate);
          fetchXML4 = this.replaceAll(fetchXML4, '{endDate}', endDate);
          fetchXML4 = fetchXML4.replace('{modifiedOnFilter}',deltaSyncFilter);
          fetchXML4 = fetchXML4.replace('{segmentPlanFilter}',planIDFilterString);
          // Replace extraAttributes for account call plans
          fetchXML4 = fetchXML4.replace('{extraAttributes}', extraAttributesValue);
          tasks.push(this.dynamics.executeFetchQuery('indskr_customercallplans',fetchXML4));
        }

        // Wait for both call plans and virtual segments sync to complete
        await Promise.all([Promise.all(tasks), virtualSegmentSyncPromise]).then(async ([response]) => {
          if(!isEmpty(response)) {
            //Contact Call Plans
            let myPositionPlans = response[0];
            let otherPosPlans = response[1];
            //Account Call Plans
            if (this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_CALL_PLAN) || this.authenticationService.hasFeatureAction(FeatureActionsMap.CALL_PLAN_HOME_SCREEN_STYLE_B)) {
              let myPositionPlansAccounts = response[2];
              //Combined Call Plans
              if(!isEmpty(myPositionPlansAccounts)) {
                myPositionPlans.push(...myPositionPlansAccounts);
              }
            }
            if (this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_CALL_PLAN)) {
              let otherPosPlansAccounts = response[3];
              if(!isEmpty(otherPosPlansAccounts)) {
                otherPosPlans.push(...otherPosPlansAccounts);
              }
            }

            // Map segmentid_Formatted by matching msdynmkt_virtualsegmentid and marketingsegmentvirtualid
            if (this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONSENT_GA_FETCHRTM)) {
              const virtualSegments = await this.virtualSegmentDataService.getVirtualSegments();
              const virtualSegmentMap = new Map();
              virtualSegments.forEach(seg => {
                virtualSegmentMap.set(seg.msdynmkt_virtualsegmentid, seg.msdynmkt_name);
              });

              // Map segmentid_Formatted for my position plans
              myPositionPlans.forEach(plan => {
                if (plan.marketingsegmentvirtualid && virtualSegmentMap.has(plan.marketingsegmentvirtualid)) {
                  plan.segmentid_Formatted = virtualSegmentMap.get(plan.marketingsegmentvirtualid);
                }
              });

              // Map segmentid_Formatted for other position plans
              otherPosPlans.forEach(plan => {
                if (plan.marketingsegmentvirtualid && virtualSegmentMap.has(plan.marketingsegmentvirtualid)) {
                  plan.segmentid_Formatted = virtualSegmentMap.get(plan.marketingsegmentvirtualid);
                }
              });
            }
            
            if(!segmentPlanID) this.searchConfigService.isContactProfileDataMappedToContacts = false;

            // Detect customer additions/removals for call plan update notifications (delta sync only)
            let addedPlans: any[] = [];
            let removedPlans: any[] = [];
            const modifiedCycleplanIdsToFreshCallPlanIds = await modifiedCycleplanIdsToFreshCallPlanIdsPromise;
            if (!fullSync && !segmentPlanID && lastModifiedForDeltaSync && existingMyPositionPlanIds.size) {
              addedPlans = myPositionPlans.filter((cp: any) => !existingMyPositionPlanIds.has(`${cp.cycleplanid}:${cp.indskr_customercallplanid}`));
              removedPlans = [...existingMyPositionPlanIds].filter(cpId => {
                const [cycleplanid, indskr_customercallplanid] = cpId.split(':');
                if (!modifiedCycleplanIdsToFreshCallPlanIds[cycleplanid]) {
                  return false;
                }
                return !modifiedCycleplanIdsToFreshCallPlanIds[cycleplanid]?.[indskr_customercallplanid];
              }).map(cpId => existingMyPositionPlans.get(cpId));
            }


            await Promise.all([
              //call plans my position
              this.disk.updateOrInsert(DB_KEY_PREFIXES.MY_POSITON_CALL_PLANS,(doc)=>{
                if(!doc || !doc.raw){
                  doc = {
                    raw:[]
                  }
                }
                if(fullSync){
                  doc.raw = myPositionPlans
                  doc.lastUpdated = now.getTime();
                  doc.ranApproveStatusFiltering = shouldFilterApprovedCallPlans;
                  return doc;
                }
                else{
                  if(!fullSync && !segmentPlanID && deletedSegmentPlans.length) doc.raw = doc.raw.filter(o=> !deletedSegmentPlans.some(r=> r.indskr_entityid==o.cycleplanid));
                  if(!fullSync && !segmentPlanID && modifiedCycleplanIdsToFreshCallPlanIds) {
                    doc.raw = doc.raw.filter(o => {
                      return !modifiedCycleplanIdsToFreshCallPlanIds[o.cycleplanid]
                        || !!modifiedCycleplanIdsToFreshCallPlanIds[o.cycleplanid]?.[o.indskr_customercallplanid];
                    });
                  }
                  /** filter out duplicate data. Used when the user selects a call plan from the list(it has segmentPlanID).
                   * indskr_customercallplanid is generated when reopening and distributing in Dynamics. Then it caused the duplicate data
                   * raw data is filtered by cycleplanid and contactId before checking indskr_customercallplanid.
                   */
                  if(!fullSync && myPositionPlans.length && segmentPlanID && this.callPlanOffline.selectedCallPlan && segmentPlanID == this.callPlanOffline.selectedCallPlan?.cycleplanid) {
                    const selectedCallPlanId = this.callPlanOffline.selectedCallPlan?.cycleplanid;
                    myPositionPlans.forEach(cp => {
                      doc.raw = doc.raw.filter(r=> !(r.cycleplanid == selectedCallPlanId && r.contactId == cp.contactId));
                    });
                  }
                  let offlineCopy = cloneDeep(doc.raw.slice());
                  const idxToDelete = [];
                  myPositionPlans.forEach(cp => {
                    const shouldFilterThisPlan = shouldFilterApprovedCallPlans && cp.statuscode !== 2;
                    cp.lastUpdated = now.getTime();
                    let idx = offlineCopy.findIndex(o=>o.indskr_customercallplanid==cp.indskr_customercallplanid)
                    if (idx >-1) {
                      if (!shouldFilterThisPlan) {
                        offlineCopy[idx] = cp;
                      } else {
                        idxToDelete.unshift(idx);
                      }
                    } else {
                      if (!shouldFilterThisPlan) {
                        offlineCopy.push(cp);
                      }
                    }
                  });
                  if (idxToDelete.length > 0) {
                    for (const idx of idxToDelete) {
                      offlineCopy.splice(idx, 1);
                    }
                  }

                  doc.raw = offlineCopy;
                  if (!doc.ranApproveStatusFiltering && shouldFilterApprovedCallPlans && needToRunApproveStatusFilterOnExistingRecords) {
                    doc.raw = doc.raw.filter(o => o.statuscode === 2);
                    doc.ranApproveStatusFiltering = true;
                  } else if (!shouldFilterApprovedCallPlans) {
                    doc.ranApproveStatusFiltering = false;
                  }
                  if(!segmentPlanID) doc.lastUpdated = now.getTime();
                  if(segmentPlanID && this.callPlanOffline.selectedCallPlan?.cycleplanid==segmentPlanID && myPositionPlans.length){
                    let selectedSegmentPlans = offlineCopy.filter(o=>o.cycleplanid == segmentPlanID);
                    selectedSegmentPlans[0].customerName = selectedSegmentPlans[0].contactFirstName + " " + selectedSegmentPlans[0].contactLastName
                    let a = {'cycleplanid': selectedSegmentPlans[0].cycleplanid,
                              'cycleplanname':selectedSegmentPlans[0].cycleplanname,
                              'repPlans':[selectedSegmentPlans[0]],
                              'indskr_enddate':selectedSegmentPlans[0].indskr_enddate,
                              'indskr_startdate':selectedSegmentPlans[0].indskr_startdate,
                              'actualCalls':selectedSegmentPlans[0].indskr_actualcalls || 0,
                              'totalGoalCalls':selectedSegmentPlans[0].indskr_hocalls || 0,
                              'actualEmails':selectedSegmentPlans[0].indskr_actualemails || 0,
                              'totalGoalEmails':selectedSegmentPlans[0].indskr_hoemails || 0,
                              'allRepCallPlansApproved': selectedSegmentPlans[0].statuscode == 2?true:false,
                              'productName':selectedSegmentPlans[0].productid_Formatted || '',
                              'suggestionApprovalneeded':  selectedSegmentPlans[0].cycleplansuggestionapprovalneeded
                            };
                            for(var id=1; id<selectedSegmentPlans.length;id++){
                              let c = selectedSegmentPlans[id];
                              c.customerName = c.contactFirstName + " " + c.contactLastName
                              a.repPlans.push(c)
                              a.actualCalls += c.indskr_actualcalls?c.indskr_actualcalls:0
                              a.totalGoalCalls += c.indskr_hocalls?c.indskr_hocalls:0
                              a.actualEmails += c.indskr_actualemails?c.indskr_actualemails:0
                              a.totalGoalEmails += c.indskr_hoemails?c.indskr_hoemails:0
                              a.allRepCallPlansApproved = a.allRepCallPlansApproved && c.statuscode == 2?true:false
                            }
                    let idx = this.callPlanOffline.segmentCallPlans.findIndex(o=>o.cycleplanid == a.cycleplanid)
                    if(idx>-1)this.callPlanOffline.segmentCallPlans[idx] = a;
                    this.callPlanOffline.selectedCallPlan = a;
                    this.callPlanOffline.segmentCallPlansList$.next({hasUpdatedData:true})
                  }
                  return doc;
                }
              }),
              //call plans other position
              this.disk.updateOrInsert(DB_KEY_PREFIXES.OTHER_POSITON_CALL_PLANS,(doc)=>{
                if(!doc || !doc.raw){
                  doc = {
                    raw:[]
                  }
                }
                if(fullSync){
                  doc.raw = otherPosPlans
                  doc.lastUpdated = now.getTime();
                  return doc;
                }
                else{
                  if(!fullSync && !segmentPlanID && deletedSegmentPlans.length) doc.raw = doc.raw.filter(o=> !deletedSegmentPlans.some(r=> r.indskr_entityid==o.cycleplanid));
                  if(!fullSync && !segmentPlanID && modifiedCycleplanIdsToFreshCallPlanIds) {
                    doc.raw = doc.raw.filter(o => {
                      return !modifiedCycleplanIdsToFreshCallPlanIds[o.cycleplanid]
                        || !!modifiedCycleplanIdsToFreshCallPlanIds[o.cycleplanid]?.[o.indskr_customercallplanid];
                    });
                  }
                  /** filter out duplicate data. Used when the user selects a call plan from the list(it has segmentPlanID).
                   * indskr_customercallplanid is generated when reopening and distributing in Dynamics. Then it caused the duplicate data
                   * raw data is filtered by cycleplanid and contactId before checking indskr_customercallplanid.
                   */
                  if(!fullSync && otherPosPlans.length && segmentPlanID && this.callPlanOffline.selectedCallPlan && segmentPlanID == this.callPlanOffline.selectedCallPlan?.cycleplanid) {
                    const selectedCallPlanId = this.callPlanOffline.selectedCallPlan?.cycleplanid;
                    otherPosPlans.forEach(cp => {
                      doc.raw = doc.raw.filter(r=> !(r.cycleplanid == selectedCallPlanId && r.contactId == cp.contactId));
                    });
                  }
                  let offlineCopy = doc.raw.slice();
                  const idxToDelete = [];
                  otherPosPlans.forEach(cp => {
                    const shouldFilterThisPlan = shouldFilterApprovedCallPlans && cp.statuscode !== 2;
                    cp.lastUpdated = now.getTime();
                    let idx = offlineCopy.findIndex(o=>o.indskr_customercallplanid==cp.indskr_customercallplanid)
                    if (idx >-1) {
                      if (!shouldFilterThisPlan) {
                        offlineCopy[idx] = cp;
                      } else {
                        idxToDelete.unshift(idx);
                      }
                    } else {
                      if (!shouldFilterThisPlan) {
                        offlineCopy.push(cp);
                      }
                    }
                  });
                  if (idxToDelete.length > 0) {
                    for (const idx of idxToDelete) {
                      offlineCopy.splice(idx, 1);
                    }
                  }
                  doc.raw = offlineCopy
                  if (shouldFilterApprovedCallPlans && needToRunApproveStatusFilterOnExistingRecords) {
                    doc.raw = doc.raw.filter(o => o.statuscode === 2);
                  }
                  if(!segmentPlanID) doc.lastUpdated = now.getTime();
                  return doc;
                }
              }).then(()=>{
                if(segmentPlanID && this.callPlanOffline.selectedCallPlan?.cycleplanid==segmentPlanID && otherPosPlans.length){
                  this.callPlanOffline.otherRepCallPlansList$.next({hasUpdatedData:true})
                }
              })
            ]).then(()=> {
              this.events.publish('callPlanActivitiesUpdated');
              if (addedPlans.length || removedPlans.length) {
                const total = addedPlans.length + removedPlans.length;
                const type = 'CALL_PLAN_UPDATES_NOTIFICATION';
                const callPlanNotification: IndNotificationDataModel = {
                  type,
                  name: this.translate.instant(type, { count: total }),
                  DateTime: Date.now(),
                  id: type + '_' + now.getTime(),
                  data: { added: addedPlans, removed: removedPlans },
                  icon: 'assets/imgs/call-plan-icon.svg',
                  isRed: false,
                  params: { count: total }
                };
                this.myAssistantService.createCustomNotification(callPlanNotification);
              }
            })
          } else {
            this.events.publish('callPlanActivitiesUpdated');
          }
        });
      } catch (error) {
        console.log(error)
      }
    }

    async getTeamCallPlans(dataRange: { from: string, to: string },fullSync? : boolean): Promise<any> {
      try {
        //Contact Call Plan
        let fetchXML1 = fetchQueries.callPlans.myPositionCallPlans;
        let fetchXML2 = fetchQueries.callPlans.otherCoveragePositionCallPlans;
        let positionIDstring = ''; let now = new Date()

        // Fetch extra attributes for Short Call Launcher FA
        let extraAttributesValue = '';
        if (this.authenticationService.hasFeatureAction(FeatureActionsMap.SHORT_CALL_LAUNCHER)) {
          extraAttributesValue = `<attribute name="indskr_totalcallgoals" /><attribute name="indskr_totalcompletedcalls" /><attribute name="indskr_primarysegmentation" />`;
        }
        // Add marketing segment attribute if BU_CONSENT_GA_FETCHRTM feature code is enabled
        if (this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONSENT_GA_FETCHRTM)) {
          extraAttributesValue += '<attribute name="indskr_marketingsegmentvirtual" alias="marketingsegmentvirtualid" />';
        }
        fetchXML1 = fetchXML1.replace('{extraAttributes}', extraAttributesValue);
        fetchXML2 = fetchXML2.replace('{extraAttributes}', extraAttributesValue);
        //position filters
        fetchXML1 = fetchXML1.split('{positionAttributeIdentifier}').join('parentpositionid');
        fetchXML2 = fetchXML2.split('{positionAttributeIdentifier}').join('parentpositionid');
        this.authenticationService.user.positions.forEach((pos)=>{
          positionIDstring+= '<value>'+ pos.ID +'</value>'
        })
        fetchXML1 = fetchXML1.split('{positionIDs}').join(positionIDstring);
        fetchXML2 = fetchXML2.split('{positionIDs}').join(positionIDstring);

        //data range
        const startDate = format(parseInt(dataRange.from),'YYYY-MM-DD');
        const endDate = format(parseInt(dataRange.to),'YYYY-MM-DD');

        fetchXML1 = this.replaceAll(fetchXML1, '{startDate}', startDate);
        fetchXML1 = this.replaceAll(fetchXML1, '{endDate}', endDate);

        fetchXML2 = this.replaceAll(fetchXML2, '{startDate}', startDate);
        fetchXML2 = this.replaceAll(fetchXML2, '{endDate}', endDate);

        fetchXML2 = this.replaceAll(fetchXML2, '{startDate}', startDate)
        fetchXML2 = this.replaceAll(fetchXML2, '{endDate}', endDate)

        let extraFilter = '';
        // Filter only approved customer call plans
        if (
          this.authenticationService.user.buSettings
          && (
            this.authenticationService.user.buSettings['indskr_displayonlyapprovedcallplansinstylea']
            || this.authenticationService.user.buSettings['indskr_displayonlyapprovedcallplansinstyleb']
          )
        ) {
          extraFilter = '<condition attribute="statuscode" operator="eq" value="2" />';
        }
        fetchXML1 = fetchXML1.replace('{customerCallPlanFilter}', extraFilter);
        fetchXML2 = fetchXML2.replace('{customerCallPlanFilter}', extraFilter);

        //segmentPlanID filter
        fetchXML1 = fetchXML1.replace('{segmentPlanFilter}','');
        fetchXML1 = fetchXML1.replace('{segmentPlanExtraAttributes}','');
        fetchXML2 = fetchXML2.replace('{segmentPlanFilter}','');
        fetchXML2 = fetchXML2.replace('{segmentPlanExtraAttributes}','');

        fetchXML2 = fetchXML2.replace(
          '{segmentPlanInnerFilter}',
          this.authenticationService.hasFeatureAction(FeatureActionsMap.CALL_PLAN_HOME_SCREEN_STYLE_B)
            // Having this FA means there could be account seg call plans data.
            // Filter out account call plans and only fetch customer call plans.
            ? '<filter><condition attribute="indskr_customertype" operator="neq" value="2"></condition></filter>'
            : '',
        );

        let tasks = [];
        tasks.push(this.dynamics.executeFetchQuery('indskr_customercallplans',fetchXML1));
        tasks.push(this.dynamics.executeFetchQuery('indskr_customercallplans',fetchXML2));

        // Fetch virtual segments in parallel if BU_CONSENT_GA_FETCHRTM feature code is enabled
        let virtualSegmentSyncPromise: Promise<void> = Promise.resolve();
        if (this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONSENT_GA_FETCHRTM)) {
          virtualSegmentSyncPromise = this.virtualSegmentDataService.syncVirtualSegments(fullSync || false, false);
        }

        /**
         * Account Call Plan - FetchXML
         * link-entity inner join is not working on the condition that from different entities(contact, account) to the same attribute(indskr_customerid)
         * That's why using additional fetchXML for the account call plan
         */
        if (this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_CALL_PLAN)) {
          //child positions
          let childPositionIds = '';
          if (!isEmpty(this.authenticationService.user.childPositions)) {
            this.authenticationService.user.childPositions.forEach((pos)=>{
              childPositionIds+= '<value>'+ pos.childPositionId +'</value>'
            })
          } else {
            childPositionIds = positionIDstring;
          }
          let fetchXML3 = fetchQueries.callPlans.myPositionCallPlansAccounts;
          let fetchXML4 = fetchQueries.callPlans.otherCoveragePositionCallPlansAccounts;
          //position filters
          fetchXML3 = fetchXML3.split('{positionAttributeIdentifierLevel1}').join('positionid');
          fetchXML4 = fetchXML4.split('{positionAttributeIdentifier}').join('positionid');
          fetchXML3 = fetchXML3.split('{positionIDsLevel1}').join(childPositionIds);
          fetchXML4 = fetchXML4.split('{positionIDs}').join(positionIDstring);
          //data range
          fetchXML3 = this.replaceAll(fetchXML3,'{startDate}', startDate);
          fetchXML4 = this.replaceAll(fetchXML4, '{startDate}', startDate);
          fetchXML3 = this.replaceAll(fetchXML3, '{endDate}', endDate);
          fetchXML4 = this.replaceAll(fetchXML4, '{endDate}', endDate);
          //delta sync filter
          fetchXML3 = fetchXML3.replace('{modifiedOnFilter}', '');
          fetchXML4 = fetchXML4.replace('{modifiedOnFilter}', '');
          //segmentPlanID filter
          fetchXML3 = fetchXML3.replace('{segmentPlanFilter}', '');
          fetchXML4 = fetchXML4.replace('{segmentPlanFilter}', '');
          // Replace extraAttributes for account call plans
          fetchXML3 = fetchXML3.replace('{extraAttributes}', extraAttributesValue);
          fetchXML4 = fetchXML4.replace('{extraAttributes}', extraAttributesValue);

          tasks.push(this.dynamics.executeFetchQuery('indskr_customercallplans',fetchXML3));
          tasks.push(this.dynamics.executeFetchQuery('indskr_customercallplans',fetchXML4));
        }

        // Wait for both call plans and virtual segments sync to complete
        return await Promise.all([Promise.all(tasks), virtualSegmentSyncPromise]).then(async ([response]) => {
          if(!isEmpty(response)) {
            //Contact Call Plans
            //Account Call Plans
            let myChildPositionPlans = response[0];
            let otherChildPosPlans = response[1];

            //Account Call Plans
            if (this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_CALL_PLAN)) {
              let myChildPositionPlansAccounts = response[2];
              let otherChildPosPlansAccounts = response[3];
              //Combined Call Plans
              if(!isEmpty(myChildPositionPlansAccounts)) {
                myChildPositionPlans.push(...myChildPositionPlansAccounts);
              }
              if(!isEmpty(otherChildPosPlansAccounts)) {
                otherChildPosPlans.push(...otherChildPosPlansAccounts);
              }
            }

            // Map segmentid_Formatted by matching msdynmkt_virtualsegmentid and marketingsegmentvirtualid
            if (this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_CONSENT_GA_FETCHRTM)) {
              const virtualSegments = await this.virtualSegmentDataService.getVirtualSegments();
              const virtualSegmentMap = new Map();
              virtualSegments.forEach(seg => {
                virtualSegmentMap.set(seg.msdynmkt_virtualsegmentid, seg.msdynmkt_name);
              });

              // Map segmentid_Formatted for my child position plans
              myChildPositionPlans.forEach(plan => {
                if (plan.marketingsegmentvirtualid && virtualSegmentMap.has(plan.marketingsegmentvirtualid)) {
                  plan.segmentid_Formatted = virtualSegmentMap.get(plan.marketingsegmentvirtualid);
                }
              });

              // Map segmentid_Formatted for other child position plans
              otherChildPosPlans.forEach(plan => {
                if (plan.marketingsegmentvirtualid && virtualSegmentMap.has(plan.marketingsegmentvirtualid)) {
                  plan.segmentid_Formatted = virtualSegmentMap.get(plan.marketingsegmentvirtualid);
                }
              });
            }

            myChildPositionPlans = orderBy(myChildPositionPlans, "modifiedon", "desc");
            otherChildPosPlans = orderBy(otherChildPosPlans, "modifiedon", "desc");
            console.log('team call plans my position', myChildPositionPlans);
            console.log('team call plans other position', otherChildPosPlans);

            this.callPlanOffline.teamPositionsOtherRepPlans = otherChildPosPlans;
            return myChildPositionPlans;
          }
        });
      } catch (error) {
        console.log(error)
      }
    }

    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<Call Plan Activities>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    public async getCallPlanActivitiesForTimeline(contact: Contact,dataRange: { from: string, to: string }, repCallPlanIDs: string[], positionIDs: string[]){
      if(!contact) return;
      if(!this.device.isOffline && contact) {
        try {
          //fetch checked-in events
          if (this.authenticationService.hasFeatureAction(FeatureActionsMap.EVENT_TOOL) || this.authenticationService.user.eventTimeLine) {
            await this.customerEventDataService.getContactCheckedInEventCallPlanTimeline(dataRange, contact, repCallPlanIDs, positionIDs);
          }
          //fetch meeting, message, phonecall activities
          let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.callplans.GET_CALLPLAN_ACTIVITIES;
          url = url.replace('{contactid}', contact.ID).replace('{startDate}', dataRange.from).replace('{endDate}', dataRange.to);
          await this.http.get(url).toPromise().then(response => {
            this.callPlanOffline.mapCallPlanTimelineActivities(response, contact);
          });
        }catch(error) { console.error('Error occured while fetching callplan timeline', error); }
        return;
      }
      //Fetch offline activities for contact timeline when the tab is on the timeline.
      else {
        const dbKeyAllActivitesTimeline: string = DB_KEY_PREFIXES.CALLPLAN_ACTIVITIES_TIMELINE + contact.ID;

        let callplanActivities: Activity[] = [];
        //Initial mapping for offline activities due to offlineline data duration
        contact.mapCallplanActivities(callplanActivities);

        this.uiService.displayLoader;
        //Retrieve contact timeline, update/scrap/track activities from DB
        try{
          await Promise.all([
            this.disk.retrieve(dbKeyAllActivitesTimeline).then((rawData)=>{
              callplanActivities = !isEmpty(rawData) ? rawData.raw : [];
            }),
          ]);
        }catch(error) { console.log(error); }

        //offline updated meeting activities check before mapping
        if(!isEmpty(callplanActivities)) {
          if(!isEmpty(this.callPlanOffline.updateActivityIdsForOfflineTimelineByContactId)) {
            const updateConIdx = this.callPlanOffline.updateActivityIdsForOfflineTimelineByContactId.findIndex(o=>o['contactId'] == contact.ID);
            if(updateConIdx > -1) {
              let updatedActivityIdsList: any[] = this.callPlanOffline.updateActivityIdsForOfflineTimelineByContactId[updateConIdx]['activityIds'] || [];
              if(!isEmpty(updatedActivityIdsList)) {
                let isUpdatedActivity: boolean = false;
                updatedActivityIdsList.forEach((actId) => {
                  const actIdx = callplanActivities.findIndex(conAct => conAct.ID == actId);
                  let foundActivity = this.activityService.getActivityByID(actId);
                  if(!isEmpty(foundActivity)) {
                    isUpdatedActivity = true;
                    if(actIdx > -1) {
                      callplanActivities[actIdx] = foundActivity;
                    }else {
                      callplanActivities.push(foundActivity);
                    }
                  }
                });
              }
            }
            //No contact selected: if all selected contacts are deleted
            const nonConIdx = this.callPlanOffline.updateActivityIdsForOfflineTimelineByContactId.findIndex(o=>o['contactId'] == '');
            if(nonConIdx > -1) {
              let deletedContactsFromActivityIdsList: any[] = this.callPlanOffline.updateActivityIdsForOfflineTimelineByContactId[nonConIdx]['activityIds'] || [];
              if(!isEmpty(deletedContactsFromActivityIdsList)) {
                let isNonContactsActivity: boolean = false;
                deletedContactsFromActivityIdsList.forEach((actId) => {
                  const actIdx = callplanActivities.findIndex(conAct => conAct.ID == actId);
                  if(actIdx > -1) {
                    isNonContactsActivity = true;
                    callplanActivities.splice(actIdx, 1);
                  }
                });
                if(isNonContactsActivity) {
                  try{
                    await this.disk.updateOrInsert(dbKeyAllActivitesTimeline, (doc) => {
                      if(!doc || !doc.raw) { doc= { raw:[] }}
                      doc.raw = callplanActivities;
                      console.log(`Updated offline activities for callplan timeline from DB: ${callplanActivities.length}`);
                      return doc;
                    });
                  }catch(error) { console.log(error); }
                }
              }
            }
          }
          //Final mapping for offline activities
          this.callPlanOffline.mapOfflineCallPlanTimelineActivities(callplanActivities, contact);
        }else {
          //In this case, no update is required if there is no local DB data.
        }
        this.uiService.dismissLoader;
        return;
      }
  }

  public async removeCallPlanActivitiesTimelineDB(contactId: string) {
    const dbKeyActivitesTimelineByContact: string = DB_KEY_PREFIXES.CALLPLAN_ACTIVITIES_TIMELINE + contactId;
    try {
      await Promise.all([
        this.disk.remove(dbKeyActivitesTimelineByContact),
      ]);
    }catch(error) {
      console.log(error);
    }
  }
  /*<<<<<<<<<<<<<<<<<<<<<<<<<<<Call Plan Activities>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

  public async getRepNamesByParentPositionId(): Promise<string[]> {
    console.log(`getRepNamesByParentPositionId`);
    let arr = [];

    let fetchXML = fetchQueries.fetchAllRepNameByPositionIds.replace('{parentPositionID}', `${this.authenticationService.user.positionID}`);
    try {
      let response = await this.dynamics.executeFetchQuery('systemusers', fetchXML);
      console.warn(`getRepNamesByPositionIds: executeFetchQuery`);
      console.log(response);

      if (!isEmpty(response)) {
        // --------------------------------User Datetime Settings-------------------------------- //
        arr = response;
      }
    } catch (error) {
      console.error('getRepNamesByPositionIds: error:', error);
    }
    return arr;
  }

  public async syncCallPlanActivities() {
    if(this.device.isOffline) return;
    this.events.publish('syncCallPlanActivities:Initiated');
    const dataRangeWithFutureBoundBySixMonths = this.authenticationService.getFromToDateRangeInUTCMiliSec(undefined);
    await this.getCallPlans(dataRangeWithFutureBoundBySixMonths,false,false);
  }
    // Summary KPI records for Sanofi China's call plan dashboard
    async getUserPositionEdgeAnalyticsMetrics(loadFromDBOnly) {
      if (
        !this.authenticationService.hasFeatureAction(FeatureActionsMap.SHORT_CALL_LAUNCHER)
        || loadFromDBOnly
      ) {
        return;
      }

      try {
        const syncInfo: EntitySyncInfo = {
          entityName: EntityNames.userPositionEdgeAnalyticsMetricses,
          totalFailed: 0,
          totalSynced: 0,
          errors: [],
          syncStatus: true
        };

        const doc = await this.disk.retrieve(DB_KEY_PREFIXES.USER_POSITION_EDGE_ANALYTICS_METRICS, true);
        let lastSyncedDateTime = doc?.lastSyncedDateTime ?? null;

        let fetchXML = fetchQueries.callPlans.userPositionEdgeAnalyticsMetrics;
        const positionId = this.authenticationService.user.positions?.find(p => p.primary)?.ID ?? null;

        // Get last-X-months value
        const today = new Date();
        const startOfQuarterDate = startOfQuarter(today);
        const startOfQuarterString = format(startOfQuarterDate, 'YYYY-MM-DD');
        const endOfQuarterString = format(endOfQuarter(today), 'YYYY-MM-DD');

        if (positionId) {
          fetchXML = fetchXML.replace('{userID}', this.authenticationService.user.systemUserID);
          fetchXML = fetchXML.replace('{primaryPositionID}', positionId);
          fetchXML = fetchXML.replace('{startOfQuarter}', startOfQuarterString);
          fetchXML = fetchXML.replace('{endOfQuarter}', endOfQuarterString);
          fetchXML = fetchXML.replace(
            '{extraFilter}',
            lastSyncedDateTime
              ? `<condition attribute='modifiedon' operator='gt' value='${lastSyncedDateTime}'/>`
              : '',
          );

          let response;
          lastSyncedDateTime = new Date().toISOString();
          try {
            response = await this.dynamics.executeFetchQuery(
              'indskr_userpositionedgeanalyticsmetricses',
              fetchXML
            );
          } catch (error) {
            console.error('getUserPositionEdgeAnalyticsMetrics: ', error);
            this.deltaService.addSyncErrorToEntitySyncInfo(syncInfo, fetchXML, error);
          }

          if (Array.isArray(response) && response.length > 0) {
            syncInfo.totalSynced = response.length;
            // Update
            await this.disk.updateOrInsert(DB_KEY_PREFIXES.USER_POSITION_EDGE_ANALYTICS_METRICS, doc => {
              if (!doc || !Array.isArray(doc.raw)) {
                doc = { raw: [] };
              }

              // Convert raw array to a map for quick access and filtering
              const rawMap = new Map();
              const startOfQuarterDateYearMonthFormatted = format(startOfQuarterDate, 'YYYY-MM-DD');

              // Process array 'raw': filter by date and replace with 'response' where necessary
              doc.raw.forEach(item => {
                if (item.indskr_yearmonth) {
                  let yearMonthFormatted;
                  try {
                    const isoString = item.indskr_yearmonth.toISOString();
                    const splitString = isoString?.split('T');
                    if (Array.isArray(splitString) && splitString[0]) {
                      yearMonthFormatted = splitString[0];
                    } else {
                      throw new Error('Wrong data');
                    }
                  } catch (error) {
                    console.error('getUserPositionEdgeAnalyticsMetrics: raw: parse #1: ', error, item);
                  }

                  if (!yearMonthFormatted) {
                    try {
                      const dateParsed = new Date(item.indskr_yearmonth);
                      if (dateParsed) {
                        const splitString = dateParsed.toISOString().split('T');
                        if (Array.isArray(splitString) && splitString[0]) {
                          yearMonthFormatted = splitString[0];
                        } else {
                          throw new Error('Wrong data');
                        }
                      }
                    } catch (error) {
                      console.error('getUserPositionEdgeAnalyticsMetrics: raw: parse #2: ', error, item);
                    }
                  }

                  if (yearMonthFormatted && !isBefore(yearMonthFormatted, startOfQuarterDateYearMonthFormatted)) {
                    rawMap.set(
                      item.indskr_userpositionedgeanalyticsmetricsid,
                      item,
                    );
                  }
                } else {
                  console.warn('getUserPositionEdgeAnalyticsMetrics: raw: indskr_yearmonth missing: ', item);
                }
              });

              // Update the map with the objects from response
              response.forEach(item => {
                if (item.indskr_yearmonth) {
                  let yearMonthFormatted;
                  try {
                    const isoString = item.indskr_yearmonth.toISOString();
                    const splitString = isoString?.split('T');
                    if (Array.isArray(splitString) && splitString[0]) {
                      yearMonthFormatted = splitString[0];
                    } else {
                      throw new Error('Wrong data');
                    }
                  } catch (error) {
                    console.error('getUserPositionEdgeAnalyticsMetrics: response: parse #1: ', error, item);
                  }

                  if (!yearMonthFormatted) {
                    try {
                      const dateParsed = new Date(item.indskr_yearmonth);
                      if (dateParsed) {
                        const splitString = dateParsed.toISOString().split('T');
                        if (Array.isArray(splitString) && splitString[0]) {
                          yearMonthFormatted = splitString[0];
                        } else {
                          throw new Error('Wrong data');
                        }
                      }
                    } catch (error) {
                      console.error('getUserPositionEdgeAnalyticsMetrics: response: parse #2: ', error, item);
                    }
                  }

                  if (yearMonthFormatted && !isBefore(yearMonthFormatted, startOfQuarterDateYearMonthFormatted)) {
                    rawMap.set(item.indskr_userpositionedgeanalyticsmetricsid, item);
                  }
                } else {
                  console.warn('getUserPositionEdgeAnalyticsMetrics: response: indskr_yearmonth missing: ', item);
                }
              });

              return {
                raw: Array.from(rawMap.values()),
                lastSyncedDateTime,
              };
            });
          }
        }
        this.deltaService.addEntitySyncInfo(syncInfo);
      } catch (error) {
        console.error('getUserPositionEdgeAnalyticsMetrics: ', error);
      }
    }
}
